import type { SupportingMethod } from '../types.js';
import { lastTwoPivots } from '../utils.js';

export const obvDivergence: SupportingMethod = ({ candles, direction }) => {
  if (candles.length < 40 || direction === 'neutral') {
    return { id: 'VF-001', name: 'OBV divergence', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Insufficient candle history or no Core direction.', dataSufficient: false, sampleSize: candles.length };
  }
  const obv: number[] = [0];
  for (let i = 1; i < candles.length; i += 1) {
    const previous = candles[i - 1]!;
    const current = candles[i]!;
    const prior = obv[i - 1] ?? 0;
    obv.push(current.close > previous.close ? prior + current.volume : current.close < previous.close ? prior - current.volume : prior);
  }
  const closes = candles.map((c) => c.close);
  const pair = lastTwoPivots(closes, direction === 'long' ? 'low' : 'high', 3);
  if (!pair) {
    return { id: 'VF-001', name: 'OBV divergence', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'No two confirmed price pivots for OBV comparison.', dataSufficient: false, sampleSize: candles.length };
  }
  const [a, b] = pair;
  const aligned = direction === 'long'
    ? closes[b]! < closes[a]! * 0.999 && obv[b]! > obv[a]!
    : closes[b]! > closes[a]! * 1.001 && obv[b]! < obv[a]!;
  return {
    id: 'VF-001',
    name: 'OBV divergence',
    status: 'experimental',
    authority: 1,
    rawSignal: aligned ? 1 : 0,
    contribution: aligned ? 1 : 0,
    direction,
    finding: aligned ? `OBV diverges constructively against the ${direction} price pivot.` : 'No qualifying OBV divergence aligned with the Core direction.',
    dataSufficient: true,
    sampleSize: candles.length,
  };
};
